import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/contexts/AuthContext";

export const LoginPage = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login, register, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) navigate("/dashboard");
  }, [user, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (isLogin) {
        await login(email, password);
        toast.success("Inicio de sesión exitoso");
      } else {
        await register({ email, password, name, phone, whatsapp, role: "cliente" });
        toast.success("Cuenta creada exitosamente");
      }
      navigate("/dashboard");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Error al procesar la solicitud");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-image" style={{ backgroundImage: `url(/hero-maxipos.jpg)` }}>
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/80 to-slate-900/40 flex items-center justify-center">
          <div className="text-white p-8 max-w-md text-center">
            <img src="/logo-maxipos.png" alt="MaxTicket" className="w-44 mx-auto mb-6 drop-shadow-2xl rounded-lg" />
            <h1 className="text-4xl font-bold mb-3 tracking-tight drop-shadow-lg">MaxTicket</h1>
            <p className="text-slate-200 text-lg drop-shadow">Sistema de gestión de incidencias de ingeniería</p>
          </div>
        </div>
      </div>
      <div className="login-form-container">
        <div className="max-w-md w-full mx-auto">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo-maxipos.png" alt="MaxTicket" className="w-10 h-10 object-contain" />
              <span className="font-bold text-xl text-slate-900">MaxTicket</span>
            </div>
            <h2 className="text-3xl font-bold text-slate-900 mb-2">{isLogin ? "Iniciar Sesión" : "Crear Cuenta"}</h2>
            <p className="text-slate-500">{isLogin ? "Ingresa tus credenciales para continuar" : "Registra una nueva cuenta de cliente"}</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-4">
            {!isLogin && (
              <>
                <div>
                  <Label htmlFor="name" className="text-slate-700">Nombre completo</Label>
                  <Input id="name" type="text" value={name} onChange={(e) => setName(e.target.value)} className="input-sharp mt-1" placeholder="Tu nombre completo" required data-testid="register-name-input" />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="phone" className="text-slate-700">Teléfono</Label>
                    <Input id="phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="input-sharp mt-1" placeholder="55 1234 5678" data-testid="register-phone-input" />
                  </div>
                  <div>
                    <Label htmlFor="whatsapp" className="text-slate-700">WhatsApp</Label>
                    <Input id="whatsapp" type="tel" value={whatsapp} onChange={(e) => setWhatsapp(e.target.value)} className="input-sharp mt-1" placeholder="55 1234 5678" data-testid="register-whatsapp-input" />
                  </div>
                </div>
              </>
            )}
            <div>
              <Label htmlFor="email" className="text-slate-700">Correo electrónico</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="input-sharp mt-1" placeholder="tu@email.com" required data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-700">Contraseña</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="input-sharp mt-1" placeholder="••••••••" required data-testid="login-password-input" />
            </div>
            <Button type="submit" className="w-full btn-primary h-12" disabled={isLoading} data-testid="login-submit-button">
              {isLoading ? "Procesando..." : (isLogin ? "Iniciar Sesión" : "Crear Cuenta")}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};
